import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { formatNumber } from '../../../../utils/helpers';
import './SelectedTeamPokerCompleted.css'; // Import Completed CSS

const SelectedTeamPokerCompleted = ({ team, contest }) => {

  // --- Hooks must be called before conditional returns --- 

  // Player Data Map (Finish & Cashed)
  const playerDataMap = useMemo(() => {
    const map = {};
    contest.players.forEach(player => {
      map[player.name] = { 
        finish: player.finish, 
        cashedFor: player.cashedFor, 
        salary: player.salary // Include salary
      };
    });
    return map;
  }, [contest.players]);

  // Calculate Total Team Cashes (Needs to apply captain bonus)
  const totalTeamCashes = useMemo(() => {
    if (!team || !team.team) return 0;
    let total = 0;
    const captainName = team.team.captain;
    const captainData = playerDataMap[captainName];
    const captainCashed = captainData?.cashedFor || 0;
    total += captainCashed; 

    team.team.flexPlayers.forEach(player => {
      const playerData = playerDataMap[player];
      total += playerData?.cashedFor || 0;
    });
    return total;
  }, [playerDataMap, team]);

  // --- Conditional return --- 
  if (!team) return null;

  // --- Logic that depends on team --- 

  // Format finish position
  const formatFinish = (finish) => {
    if (finish === 0 || finish === null) return '-'; // Should not happen in completed, but safe fallback
    if (finish === -1) return 'Out'; // Assuming -1 means eliminated/not placed
    return finish.toString();
  };

  // Get salaries for display (using the map)
  const captainSalary = playerDataMap[team.team.captain]?.salary || 0;
  const flexPlayerSalaries = team.team.flexPlayers.map(
    player => playerDataMap[player]?.salary || 0
  );

  return (
    <div className="selected-team-container-poker-completed"> {/* UPDATED CLASS */} 
      <div className="selected-team-header">
        <h2>{team.entryName || team.username}'s Final Team</h2> {/* Updated Header */} 
      </div>
      <div className="selected-team-content">
        <table className="selected-team-table">
          <thead>
            <tr>
              <th>Pos</th>
              <th>Name</th>
              <th className="show-on-desktop">Salary</th>
              <th>Finish</th>
              <th>Cashed</th>
            </tr>
          </thead>
          <tbody>
            {(() => { // Captain Row
              const captainFinish = playerDataMap[team.team.captain]?.finish;
              // Removed isCaptainActive and captainStatusClass
              const captainCashed = playerDataMap[team.team.captain]?.cashedFor || 0;
              return (
                <tr>
                  <td><span className="position-label position-label--cpt">CPT*</span></td>
                  {/* Removed captainStatusClass */}
                  <td className="captain-cell">
                    {team.team.captain}
                  </td>
                  {/* Removed captainStatusClass */}
                  <td className="show-on-desktop">${formatNumber(captainSalary)}</td>
                  {/* Removed captainStatusClass */}
                  <td>{formatFinish(captainFinish)}</td>
                  {/* Removed captainStatusClass, always show cashed amount, removed bonus indicator */}
                  <td className="cashed-amount">
                    ${formatNumber(captainCashed)} 
                  </td>
                </tr>
              );
            })()}
            {team.team.flexPlayers.map((player, index) => { // Flex Player Rows
              const playerFinish = playerDataMap[player]?.finish;
              // Removed isPlayerActive and playerStatusClass
              const playerCashed = playerDataMap[player]?.cashedFor || 0;
              const playerSalary = flexPlayerSalaries[index];
              return (
                <tr key={index}>
                  <td><span className="position-label">FLEX</span></td>
                  {/* Removed playerStatusClass */}
                  <td className="flex-cell">
                    {player}
                  </td>
                  {/* Removed playerStatusClass */}
                  <td className="show-on-desktop">${formatNumber(playerSalary)}</td>
                  {/* Removed playerStatusClass */}
                  <td>{formatFinish(playerFinish)}</td>
                  {/* Removed playerStatusClass, always show cashed amount */}
                  <td className="cashed-amount">
                    ${formatNumber(playerCashed)}
                  </td>
                </tr>
              );
            })}
          </tbody>
          {/* Added Footer for Totals */}
          <tfoot>
            <tr className="totals-row">
              <td className="totals-label" colSpan="2">Totals:</td>
              {/* Salary Total (Desktop Only) */}
              <td className="show-on-desktop totals-value">${formatNumber(team.teamSalary)}</td>
              {/* Empty Cell under Finish */} 
              <td></td> 
              {/* Cashed Total (with captain bonus) */}
              <td className="totals-value">${formatNumber(totalTeamCashes)}</td> 
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
  );
};

SelectedTeamPokerCompleted.propTypes = {
  team: PropTypes.object.isRequired,
  contest: PropTypes.object.isRequired
};

export default SelectedTeamPokerCompleted;
